/** given text is copied into clipboard*/
export default function getChatbotPath(baseUrl, projectId, env, chatbotToken) {
  if (!baseUrl.endsWith('/')) {
    baseUrl += '/'
  }
  return `${baseUrl}chatbot-client/v1/static/${projectId}_${env}.js?token=${chatbotToken}`
}
